(function () {
  const content = document.querySelector(".js-article-content");
  if (!content) return;

  const links = content.querySelectorAll("a");

  const buttonTexts = [
    "商品を見る",
    "View Product",
    "查看商品"
  ];

  links.forEach((link) => {
    const text = (link.textContent || "")
      .replace(/\s+/g, "")
      .trim();

    const normalizedButtonTexts = buttonTexts.map((text) =>
      text.replace(/\s+/g, "")
    );

    if (!normalizedButtonTexts.includes(text)) return;

    link.classList.add("button", "purchase-button");
  });
})();